module.exports = __webpack_public_path__ + "log_out_1.d5239100923a27bb37c6561a7599bfc7.svg";